import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  sendNotification,
  getStats,
  rowSelect,
  editShipAddress,
} from '../../store/action/patient.action'
import {
  Row,
  Col,
  Button,
  Modal,
  Card,
  Form,
  Input,
  Select,
  message,
  DatePicker,
} from 'antd'
import _ from 'lodash'
import '../../css/patient.scss'
import moment from 'moment'
import { constants } from '../../constants'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'

const EditShipAddress = (props) => {
  var form = useRef(null)

  const [isStateAvailable, setIsStateAvailble] = useState(undefined)
  useEffect(() => {
    var date = props.date ? moment(props.date) : moment()
    form.current && form.current.setFieldsValue({ date })
  }, [props.date])

  var handleCancel = () => {
    form.current && form.current.resetFields()
    props.onClose()
  }

  useEffect(
    () => setIsStateAvailble(props.patient.shipaddress?.country == 'US'),
    [props]
  )

  var handleOk = () => {
    form.current.validateFields().then((values) => {
      props.addEvent(
        props.patient._id,
        {
          ...values,
          date: props.date && props.hideDate ? props.date : values.date,
        },
        props.patient
      )
      // form.current && form.current.resetFields();
      props.onSuccess()
    })
  }

  var disabledDate = (current) => {
    // Can not select days before today
    return current && current < moment().subtract(1, 'd').endOf('day')
  }

  var renderBody = () => {
    return (
      <Card bordered={true}>
        <Col>
          <Row>
            <Col flex={'auto'}>
              <Form
                ref={form}
                name='normal_login'
                layout={'vertical'}
                initialValues={props.patient.shipaddress}
                labelCol={{ span: 6 }}
              >
                <Col flex={'50%'} gutter={25} style={{ maxWidth: '650px' }}>
                  <Row justify={'center'}>
                    <Col flex={'100%'}>
                      <Row gutter={25}>
                        <Col flex={'auto'}>
                          <Form.Item
                            label='Address Line 1'
                            name='addressline1'
                            rules={[
                              {
                                required: true,
                                message: 'Please enter your address.',
                              },
                            ]}
                          >
                            <Input maxLength={100} />
                          </Form.Item>

                          <Form.Item
                            label='City'
                            name='city'
                            rules={[
                              {
                                required: true,
                                message: 'Please select your city name.',
                              },
                            ]}
                          >
                            <Input maxLength={20} />
                          </Form.Item>
                          <Form.Item
                            label='Zip Code'
                            name='zip'
                            rules={[
                              {
                                required: true,
                                message: 'Please enter your zip code',
                              },
                            ]}
                          >
                            <Input maxLength={20} />
                          </Form.Item>
                        </Col>
                        <Col flex={'auto'}>
                          <Form.Item
                            label='Address Line 2'
                            name='addressline2'
                            rules={[
                              {
                                required: false,
                              },
                            ]}
                          >
                            <Input />
                          </Form.Item>

                          {isStateAvailable && (
                            <Form.Item
                              label='State'
                              name='state'
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select your state.',
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                defaultValue={'Alabama'}
                              >
                                {constants.USA_STATE.map((s) => {
                                  return (
                                    <Select.Option value={s}>{s}</Select.Option>
                                  )
                                })}
                              </Select>
                            </Form.Item>
                          )}

                          <Form.Item
                            label='Country'
                            name='country'
                            rules={[
                              {
                                required: true,
                                message: 'Please select your country.',
                              },
                            ]}
                          >
                            <Select
                              defaultValue={'US'}
                              onChange={(e) => {
                                e == 'US'
                                  ? setIsStateAvailble(true)
                                  : setIsStateAvailble(false)
                              }}
                            >
                              {constants.COUNTRYS.map((c) => {
                                return (
                                  <Select.Option value={c.code}>
                                    {c.name}
                                  </Select.Option>
                                )
                              })}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Form>
            </Col>
          </Row>
        </Col>
      </Card>
    )
  }

  return (
    <Modal
      className={'filterModal'}
      visible={props.visible}
      closable={false}
      maskClosable={false}
      onCancel={handleCancel}
      onOk={handleOk}
      width={'70%'}
      okText={'Send'}
    >
      {renderBody()}
    </Modal>
  )
}

EditShipAddress.propTypes = {
  customer: PropTypes.object,
  patientid: PropTypes.string,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  visible: PropTypes.bool,
  date: PropTypes.object,
  hideDate: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    patient: state.patient.patient,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addEvent: (id, input, state) => dispatch(editShipAddress(id, input, state)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditShipAddress)
